export default __webpack_public_path__ + "static/media/blk-cmnt.1fb988e3.svg";